import Url from 'environment';
import Api from '../../api';

class UsersService extends Api {
  constructor() {
    super();
  }

  /**
   * @description 내정보 가져오기
   * @returns
   */
  async getInfo() {
    const res = await this.commonAjax('get', Url.named, `me`);

    return res;
  }

  /**
   * @description 닉네임 조회
   * @returns
   */
  async userFind(nick) {
    const res = await this.commonAjax('get', Url.named, `users`, { nick });

    return res;
  }
}

export default new UsersService();
